export default {
  sectionTitle: {
    en: '{gender, select, female {Perfumes} male {Colognes}}',
  },
}
